import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetFloodedRiceQuery,
  usePublicGetFloodedRiceQuery,
  useGetFloodedRiceDefaultsQuery,
  usePublicGetFloodedRiceDefaultsQuery,
  useGetFloodedRiceMinorSeasonsQuery,
  usePublicGetFloodedRiceMinorSeasonsQuery,
  useGetFloodedRiceMinorSeasonsDefaultsQuery,
  usePublicGetFloodedRiceMinorSeasonsDefaultsQuery,
  useUpdateFloodedRiceMutation,
  useUpdateFloodedRiceMinorSeasonMutation,
  useDeleteFloodedRiceMinorSeasonMutation,
  useCreateFloodedRiceMinorSeasonMutation
} from '../features/modules/floodedRiceApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting flooded rice data based on the current route.
 */
export const useContextAwareGetFloodedRice = createContextAwareHook(
  useGetFloodedRiceQuery,
  usePublicGetFloodedRiceQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting flooded rice defaults based on the current route.
 */
export const useContextAwareGetFloodedRiceDefaults = createContextAwareHook(
  useGetFloodedRiceDefaultsQuery,
  usePublicGetFloodedRiceDefaultsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting flooded rice minor seasons based on the current route.
 */
export const useContextAwareGetFloodedRiceMinorSeasons = createContextAwareHook(
  useGetFloodedRiceMinorSeasonsQuery,
  usePublicGetFloodedRiceMinorSeasonsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting flooded rice minor season defaults based on the current route.
 */
export const useContextAwareGetFloodedRiceMinorSeasonDefaults = createContextAwareHook(
  useGetFloodedRiceMinorSeasonsDefaultsQuery,
  usePublicGetFloodedRiceMinorSeasonsDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateFloodedRiceMutation,
  useUpdateFloodedRiceMinorSeasonMutation,
  useDeleteFloodedRiceMinorSeasonMutation,
  useCreateFloodedRiceMinorSeasonMutation
}; 